import { getStore } from '../store/store';
import type BrowserHeightBucket from '../store/schema/BrowserHeightBucket';

export default function getBrowserHeightBucket(): BrowserHeightBucket | undefined {
    const storeBrowserHeightBucket = getStore().browserHeightBucket;
    return storeBrowserHeightBucket ? storeBrowserHeightBucket : undefined;
}
